import { selectStandardProps } from "@/utils/componentUtils";
import { Select } from "antd";
import { useEnumeration } from "../../../../common/api/queries";
import type { UUID } from "../../../../typings/global";
import { AgentEducationBase } from "../../../agent/types";
import { formatAgentEducationName } from "../../../agent/utils";
import { EnumerationType } from "../../enums";

type Props<T extends boolean> = {
  value?: T extends true ? UUID[] : UUID;
  allowClear?: boolean;
  isMultiple?: T;
  dataSource?: AgentEducationBase[];
  onChange?: (data: T extends true ? UUID[] : UUID) => void;
  style?: React.CSSProperties;
};

export const AgentEducationSelect = <T extends boolean>({
  value,
  allowClear,
  isMultiple,
  dataSource,
  onChange,
  style,
}: Props<T>) => {
  const educationEnums = useEnumeration(EnumerationType.AGENT_EDUCATIONS);
  const data = dataSource ?? educationEnums;

  return (
    <Select
      style={style}
      {...selectStandardProps}
      allowClear={allowClear}
      maxTagCount="responsive"
      mode={isMultiple ? "multiple" : undefined}
      options={data.map((education) => ({
        label: formatAgentEducationName(education),
        value: education.id,
      }))}
      onChange={onChange}
      value={value}
    />
  );
};
